import { logoLinksSearchStyles as styles } from "@insite/content-library/Widgets/Header/LogoLinksSearch";
import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

/* LogoLinkSearch zone styles */
styles.container = {
    ...styles.container,
    css: css`
        ${styles.container.css}
        align-items: center;
    `,
};

styles.logoWrapper = {
    ...styles.logoWrapper,
    css: css`
        ${styles.logoWrapper?.css}
        margin: 0;
        width: 235px;
        padding-block: 8px;

        .home-page-link {
            img {
                max-height: 78px;
                max-width: 100%;

                ${mediaQueriesBP.minLG} {
                    height: auto;
                }
            }
        }

        ${mediaQueriesBP.minMD} {
            padding-right: 0;
            padding-left: 0;
        }

        ${mediaQueriesBP.maxMD} {
            text-align: center;
        }
    `,
};

styles.searchMenuWrapper = {
    ...styles.searchMenuWrapper,
    css: css`
        ${styles.searchMenuWrapper?.css}
        padding-right: 0;
        padding-left: 0;
        width: calc(100% - 314px);
        padding-block: 16px;

        .list-wrapper {
            padding-bottom: 16px;
        }

        .list-link {
            ${TypographyStyle} {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                text-transform: none;
            }
        }

        ${mediaQueriesBP.maxLG} {
            flex-grow: initial;
        }
    `,
};

/* SearchInput widget styles */
searchInputStyles.input = {
    ...searchInputStyles.input,
    border: "rectangle",
    mergeCss: true,
    cssOverrides: {
        ...searchInputStyles.input?.cssOverrides,
        formField: css`
            ${searchInputStyles.input?.cssOverrides?.formField}
            width: 100%;
        `,
    },
};

searchInputStyles.popoverContentBody = {
    ...searchInputStyles.popoverContentBody,
    css: css`
        ${searchInputStyles.popoverContentBody?.css}

        ${mediaQueriesBP.maxXLG} {
            width: calc(100% - 370px);
        }

        ${mediaQueriesBP.minXLG} {
            width: 830px;
        }
    `,
};

searchInputStyles.searchHistoryStyles = {
    ...searchHistoryStyles,
    ...searchInputStyles.searchHistoryStyles,
    wrapper: {
        ...searchHistoryStyles?.wrapper,
        ...searchInputStyles.searchHistoryStyles?.wrapper,
        css: css`
            ${searchHistoryStyles?.wrapper?.css}
            ${searchInputStyles.searchHistoryStyles?.wrapper?.css}
            width: 100%;
        `,
    },
};

searchInputStyles.autocompleteWrapper = {
    ...searchInputStyles.autocompleteWrapper,
    css: css`
        ${searchInputStyles.autocompleteWrapper?.css}
        ${mediaQueriesBP.minLG} {
            flex-direction: row-reverse;
        }
    `,
};

searchInputStyles.autocompleteColumnWrapper = {
    ...searchInputStyles.autocompleteColumnWrapper,
    css: css`
        ${searchInputStyles.autocompleteColumnWrapper?.css}
        width: 50%;
    `,
};
